import {
  CREATE_HUBBLE,
  UPDATE_HUBBLE,
  UNLOAD_HUBBLE,
  HUBBLE_FETCHED_SUCCESS,
  HUBBLE_FETCHED_FAILED,
  RESET_HUBBLE,
  UPDATE_ACTION_POOL,
  PUSHED_HUBBLE,
  HUBBLE_TOGGLE_FAILED,
  HUBBLE_TOGGLE_SUCCESS,
  HUBBLE_OFFLINE_ORDER_FETCHED_SUCCESS,
  HUBBLE_OFFLINE_ORDER_FETCHED_FAILED,
} from "../constants/actionTypes";

const initialState = {
  hubbles: [],
  actionPool: [],
  message: "",
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
  offlinePager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_HUBBLE:
    case UPDATE_HUBBLE:
      return {
        ...state,
        message: action.payload?.msg || "",
      };

    case RESET_HUBBLE:
      return {
        ...state,
        message: "",
      };

    case HUBBLE_FETCHED_SUCCESS:
      return {
        ...state,
        hubbles: action.payload.hubbles || [],
        pager: action.payload.pager || initialState.pager,
      };

    case HUBBLE_FETCHED_FAILED:
      return {
        ...state,
        hubbles: [],
      };

    case UPDATE_ACTION_POOL:
      return {
        ...state,
        actionPool: action.payload?.data || [],
      };

    case PUSHED_HUBBLE:
      return {
        ...state,
        hubbles: state.hubbles.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              pushed_at: action.payload.date,
            };
          }
          return item;
        }),
      };

    case HUBBLE_TOGGLE_FAILED:
      return state;

    case HUBBLE_TOGGLE_SUCCESS:
      return {
        ...state,
        hubbles: state.hubbles.map((item) => {
          if (item.id !== action.payload.id) return item;
          return {
            ...item,
            is_active: action.payload.active,
          };
        }),
      };

    case UNLOAD_HUBBLE:
      return initialState;

    case HUBBLE_OFFLINE_ORDER_FETCHED_SUCCESS:
      return {
        ...state,
        offlineOrders: action.payload.orders || [],
        offlinePager: action.payload.pager || initialState.offlinePager,
      };

    case HUBBLE_OFFLINE_ORDER_FETCHED_FAILED:
      return {
        ...state,
        offlineOrders: [],
      };

    default:
      return state;
  }
};
